import React, { useEffect, useState, useContext } from 'react';
import { AppContext } from '../../context/app/appContext';

const AllUsers = () => {
    const [allUsers, setAllUsers] = useState(0)

    const appContext = useContext(AppContext);

    useEffect(() => {
        loadActiveEmployees()
    }, [appContext.employees])
    const loadActiveEmployees = () => {
        setAllUsers(appContext.employees.length)
    }

    return (
        <div style={{ height: '120px', width: '100%', textAlign: 'center', paddingTop: '20px', display: 'flex', flexDirection: 'column',}}>
            <div style={{fontSize: 20, fontStyle: 'SFProText-Bold', color: 'rgba(7, 112, 204, 1)', flex: 1}}>All Users</div>
            <div style={{fontSize: 40, fontStyle: 'SFProText-Bold', color: 'rgba(7, 112, 204, 1)', flex: 1}}>{allUsers}</div>
        </div>
    )

}
export default AllUsers